module.exports = __webpack_public_path__ + "assets/icon-check-checked.965ebcc6.png";